import { createContext } from "react";

const DropCtx = createContext({ open: false, setOpen: () => {} });

export default DropCtx;